interface ShowMoreButtonIProps {
  isExpanded: boolean
  onClick: () => void
}

export const ShowMoreButton = ({
  isExpanded,
  onClick,
}: ShowMoreButtonIProps) => (
  <button
    onClick={onClick}
    style={{
      display: 'block',
      margin: '0 auto',
      color: '#3157ad',
      marginTop: 5,
      fontWeight: 500,
      fontSize: '14px',
    }}
  >
    Show {isExpanded ? 'Less' : 'More'}
  </button>
)
